
<div class="sidebar-body-layout" [ngClass]="{'collapsed': collapsed}">
  <div class="sidebar-toggle-btn-layout">
    <button class="toggle-btn" (click)="toggleSidebar()">
      <span *ngIf="!collapsed">«</span>
      <span *ngIf="collapsed">»</span>
    </button>
  </div>
  <div class="ejs-treeview-body" *ngIf="!collapsed">
    <ejs-treeview 
      #menuTree id="menuTree" 
      cssClass="main-treeview"
      [fields]="fields" 
      [expandOn]="'Click'"
      (nodeSelected)="onMenuItemClicked($event)"
      (created)="onTreeCreated($event)"
    >
      <ng-template #nodeTemplate let-data>
        <div class="tree-node">
          <div class="e-list-icon images"><span [class]="data.icon"></span></div>
          <span>{{ data.name | translate }}</span>
        </div>
      </ng-template>
    </ejs-treeview>
  </div>
</div>